import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconListBullet24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconListBullet24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M5 6.75a1 1 0 1 1-2 0 1 1 0 0 1 2 0m15.198.75a.75.75 0 0 0 0-1.5H7.25a.75.75 0 1 0 0 1.5zM17.21 11a.75.75 0 0 0 0-1.5H7.25a.75.75 0 0 0 0 1.5zm3.738 2.75a.75.75 0 0 1-.75.75H7.25a.75.75 0 0 1 0-1.5h12.947a.75.75 0 0 1 .75.75M17.21 18a.75.75 0 0 0 0-1.5H7.25a.75.75 0 0 0 0 1.5zM4 11.25a1 1 0 1 0 0-2 1 1 0 0 0 0 2m1 2.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-1 4.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconListBullet24);
